import { h, render, Component, toChildArray, Fragment } from "preact";
import { useEffect, useRef, useState, useMemo } from "preact/hooks";
import { getLogging } from "../../logging";

const ShadowLogging = getLogging("shadow");

export interface IShadowProps {
   children: h.JSX.Element | h.JSX.Element[];
}
export default function Shadow({ children }: IShadowProps) {
   const container = useRef<HTMLDivElement>();
   const [root, setRoot] = useState<HTMLElement | ShadowRoot>(null);
   const rnd = useMemo(() => Math.random(), []);

   ShadowLogging.log("Call to Shadow", rnd);

   const render_content = (content: any) => {
      if (root) {
         render(content, root, root.firstChild as any);
      }
   };

   useEffect(() => {
      if (container.current) {
         if (root) {
            render_content(null); //Unrender
            root.parentElement.remove();
         }
         // let iframe = document.createElement("iframe");
         // iframe.style.width = "100%";
         // iframe.onload = (evt) => {
         //    iframe.contentWindow.requestAnimationFrame(() => {
         //       iframe.contentWindow.requestAnimationFrame(() => {
         //          iframe.style.height = (iframe.contentWindow.document.body.scrollHeight + 50) + "px";
         //       });
         //    })
         // }
         // container.current.appendChild(iframe);
         // setRoot(iframe.contentWindow.document.body);

         let p = document.createElement("x-shadow");
         container.current.appendChild(p);
         let shadow = p.attachShadow({ mode: "open" });
         ShadowLogging.log("Creating Shadow", rnd, shadow);
         setRoot(shadow);
      }

      return () => {
         if (root) {
            render_content(null);
            root.parentElement.remove();
            setRoot(null);
         }
      };
   }, [container]);

   useEffect(() => {
      ShadowLogging.log("Rendering Shadow", rnd);
      render_content(h(Fragment, {}, ...toChildArray(children)));
   }, [root, children]);

   return <div ref={container}></div>;
}
